import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteAccountingPeriod } from './accountingPeriod';
import {
  ACCOUNTING_PERIOD_METADATA_KEY,
  ACCOUNTING_PERIODS_KEY,
} from './constants';

export const useDeleteAccountingPeriod = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteAccountingPeriod,
    onSuccess: () => {
      // Invalidate and refetch all accounting periods queries
      queryClient.invalidateQueries({ queryKey: [ACCOUNTING_PERIODS_KEY] });
      // Also invalidate metadata since periods might affect counts
      queryClient.invalidateQueries({
        queryKey: [ACCOUNTING_PERIOD_METADATA_KEY],
      });
    },
  });
};
